var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger row-margin"},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.errorList()),function(error,index){return _c("error-item",{key:error.message,tag:"li",attrs:{"error":error,"index":index}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }